module.exports = __webpack_public_path__ + "img/picsum_865-1920x1080.6c123b30.jpg";